import React from 'react';

import { Text } from '@qality/common-components/src/atoms/Text';

import { QAlityFreeLabelStyled } from './QAlityFreeLabel.styled';

export const QAlityFreeLabel = ({ text, linkName, linkUrl }: any) => (
  <QAlityFreeLabelStyled>
    <Text>
      {text}&nbsp;
      <a href={linkUrl} target='_blank' rel='noreferrer'>
        {linkName}
      </a>
    </Text>
  </QAlityFreeLabelStyled>
);
